import { formatCurrency } from "src/shared/hooks/formatCurrency"
import { RoleNames } from "src/shared/hooks/useAuth"
import Icon from "src/shared/icons"
import { getExactDate } from "src/utils/date"

export const getRowsRecepcion = (array: any, usuario_id: string, onEdit: (gastoData: any) => void, onDelete: (gastoData: any) => void, formatCustomDate, categoryId?: string) => {

    return array?.map((gastoData) => {
        const enabledActions = gastoData.corte_id === null && gastoData.usuario_id === usuario_id
        const fechaRegistro = getExactDate(gastoData.fecha_registro)

        return {
            value: [
                {
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {gastoData?.usuario?.roles[0]?.nombre === RoleNames.admin ||
                                gastoData?.usuario?.roles[0]?.nombre === RoleNames.superadmin
                                ? "A-"
                                : "R-"}
                            {gastoData?.folio}
                        </p>
                    ),
                },
                ...(categoryId ? [] : [{
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {gastoData.categoria_gasto.categoria}
                        </p>
                    ),
                }]),
                {
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {gastoData.subcategoria_gasto?.subcategoria || "N/A"}
                        </p>
                    ),
                },
                {
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {gastoData.comentarios || "N/A"}
                        </p>
                    ),
                },
                {
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {formatCurrency(gastoData.monto)}
                        </p>
                    ),
                },
                {
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {gastoData?.usuario?.nombre} {gastoData?.usuario?.apellido_paterno}
                        </p>
                    ),
                },
                {
                    value: (
                        <p className={gastoData.eliminado ? "gastos-table-row-eliminado" : ""}>
                            {fechaRegistro
                                ? `${formatCustomDate((fechaRegistro), "DD/MMM/YY")} ${formatCustomDate((fechaRegistro), "hh:mm a")}`
                                : ""}
                        </p>
                    ),
                },
                {
                    value: gastoData.eliminado ? (
                        <div className="gastos-table__icons">
                            <p className="gasto-eliminado-pill">Eliminado</p>
                        </div>
                    ) : (
                        <div className="gastos-table__icons">
                            <div className="gastos-table__icons__item">
                                <Icon
                                    name="editFill"
                                    height={"20px"}
                                    width={"20px"}
                                    color="var(--primary)"
                                    style={{
                                        opacity:
                                            enabledActions
                                                ? 1
                                                : 0.5, pointerEvents: enabledActions ? "auto" : "none",
                                        cursor: enabledActions ? "" : "not-allowed"
                                    }}
                                    onClick={() => enabledActions ? onEdit(gastoData) : null}
                                />
                            </div>
                            <div className="gastos-table__icons__item">
                                <Icon
                                    name="trashFilled"
                                    color="var(--primary)"
                                    height={"20px"}
                                    width={"20px"}
                                    style={{
                                        opacity:
                                            enabledActions
                                                ? 1
                                                : 0.5,
                                        pointerEvents: enabledActions ? "auto" : "none",
                                        cursor: enabledActions ? "" : "not-allowed"
                                    }}
                                    onClick={() => enabledActions ? onDelete(gastoData) : null}
                                />
                            </div>
                        </div>
                    ),
                },
            ],
        }
    })
}